/**
 * « Une facture déjà envoyée et payée, pourquoi l'offre reste acceptée ? » :
 * la liste des offres ne montrait que la réponse du client. Une offre dont la
 * facture finale est partie se lit « Facturé », et « Payé » une fois cette
 * facture réglée.
 */

/** Une facture qui n'est pas partie chez le client. */
const PAS_PARTIE = new Set(['Brouillon', 'Annulée']);

/**
 * @param {object} d offre
 * @param {object[]} factures toutes les factures
 * @param {object[]} [chantiers] chantiers, pour les factures faites depuis le
 *   chantier de l'offre
 * @returns {string} « Payé », « Facturé », ou le statut de l'offre
 */
export function etatOffre(d, factures, chantiers = []) {
  if (!d || d.statut === 'Refusé') return d?.statut;
  const sesChantiers = new Set(
    (chantiers || [])
      .filter((c) => c.devisId != null && String(c.devisId) === String(d.id))
      .map((c) => String(c.id)),
  );
  // La facture finale : ni acompte (ni facture d'avancement), ni avoir.
  const finales = (factures || []).filter(
    (f) =>
      f.type !== 'acompte' &&
      f.type !== 'avoir' &&
      !f.acompte &&
      f.statut &&
      !PAS_PARTIE.has(f.statut) &&
      ((f.devisId != null && String(f.devisId) === String(d.id)) ||
        (f.siteId != null && sesChantiers.has(String(f.siteId)))),
  );
  if (!finales.length) return d.statut;
  return finales.every((f) => f.statut === 'Payée') ? 'Payé' : 'Facturé';
}

/**
 * L'état affiché dans Offres : l'offre seulement, sans rien de la facture.
 * Une offre devenue facture (envoyée ou payée) reste « Accepté ».
 *
 * @param {object} d offre
 * @param {object[]} factures toutes les factures
 * @param {object[]} chantiers tous les chantiers
 * @returns {string|undefined} En attente, Accepté ou Refusé
 */
export function etatOffreSeule(d, factures, chantiers = []) {
  const etat = etatOffre(d, factures, chantiers);
  return etat === 'Facturé' || etat === 'Payé' ? 'Accepté' : etat;
}

/**
 * Une offre « En attente » déjà transformée en facture n'attend plus la
 * réponse du client : l'accueil la comptait encore (« 9 en attente ») quand
 * les cases et la liste des offres en montraient 8.
 *
 * @param {object} d offre
 * @param {object[]} factures toutes les factures
 * @returns {boolean} vrai si l'offre attend encore la réponse du client
 */
export function attendReponse(d, factures) {
  if (d?.statut !== 'En attente') return false;
  return !(factures || []).some(
    (f) =>
      f.devisId != null &&
      String(f.devisId) === String(d.id) &&
      f.type !== 'acompte' &&
      f.type !== 'avoir' &&
      f.statut !== 'Annulée',
  );
}
